import $ from "jquery";

export function smooth_scroll() {
  //トップに戻る
  $(".js-smooth_scroll").click(function () {
    const header_height = $(".l-header").height();
    const speed = 500;
    const href = $(this).attr("href");
    const target = $(href == "#" || href == "" ? "html" : href);
    const position = target.offset().top - header_height;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });

  // ページ外リンク
  $(window).on("load", function () {
    const header_height = $(".crf-menu").height();
    if (document.URL.match("#")) {
      const str = location.href;
      const cut_str = "#";
      const index = str.indexOf(cut_str);
      const href = str.slice(index);
      const target = href;
      const position = $(target).offset().top - header_height;
      $("html, body").scrollTop(position);
      return false;
    }
  });
}